const apiUrl = process.env.REACT_APP_API_URL;
export const PostProjecteConfiguracioPes = async (id: string, id_confi: string, pes : string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id}/configuracio/${id_confi}/pes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({pes: pes})
        });
        if (!response.ok) {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
